// @flow
import * as React from 'react';
import {IntlProvider} from 'react-intl';
import BILLoader from '../BILLoader/BILLoader';
import './IntlApp.less';

type IntlAppProps = {
   locale?: string,
   loading: boolean,
   routeLocale: string,
   changeLanguage: (locale: string) => void,
   messages?: {[key: string]: string},
   children?: React.Node,
};

export default class IntlApp extends React.Component<IntlAppProps> {
   componentDidMount() {
      this.checkLanguage();
   }

   componentDidUpdate() {
      this.checkLanguage();
   }

   checkLanguage() {
      const {routeLocale, locale, messages, loading, changeLanguage} = this.props;
      if (!loading && (routeLocale !== locale || !messages)) {
         changeLanguage(routeLocale);
      }
   }

   render() {
      const {locale, messages, loading, children} = this.props;

      if (loading || !locale || !messages) {
         return (
            <div className="intl-spinner-container">
               <BILLoader />
            </div>
         );
      }

      return (
         <IntlProvider locale={locale} key={locale} messages={messages}>
            {children}
         </IntlProvider>
      );
   }
}
